import apiRatingClient from "../../apiclients/rating";
/* eslint-disable import/prefer-default-export */
export async function getRating(params) {
  return apiRatingClient
    .post(`/ratings?api-version=1.0`, params)
    .then(response => {
      if (response) {
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}

